import { Component, OnInit } from '@angular/core';
import { NavigationStart, Router,Event, NavigationEnd } from '@angular/router';
import { LanguageService } from '@meddatacore/common';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent  implements OnInit {
  constructor(
    public _router: Router,
    private languageService: LanguageService,
    private spinner: NgxSpinnerService
  ) {
    this._router.events.subscribe((routerEvent: Event) => {
      if (routerEvent instanceof NavigationStart) {
        this.spinner.show('page-loader');
      }
      if (routerEvent instanceof NavigationEnd) {
        this.spinner.hide('page-loader');
      }
      window.scrollTo(0, 0);
    });
  }

  ngOnInit(): void {
    this.languageService.setLanguage(this.languageService.translate.currentLang)
  }
}
